import { getApi, postApi } from 'utils/Api';
import { prepareUrlParams } from 'utils/Urls';
import {
  FetchMissingReportSummaryResponse,
  MissingReportType,
  FetchMissingReportListResponse,
  SendReminderResponse,
  SendReminderPayload,
} from './types/missingInformationReportTypes';

export const MISSING_REPORT_SUMMARY = 'MISSING_REPORT_SUMMARY';
export const MISSING_REPORT_LIST = 'MISSING_REPORT_LIST';
export const SEND_REMINDER = 'SEND_REMINDER';

const missingInformationReport = {
  fetchMissingReportSummary: () => {
    return getApi<FetchMissingReportSummaryResponse>({
      url: '/missing-report/summary',
      responseSchema: {},
    });
  },

  fetchMissingReportList: <T extends MissingReportType>(queryParams: {
    type: T;
    limit: number;
    page: number;
  }) => {
    const urlParamsV2 = prepareUrlParams(queryParams);
    const url = '/missing-report/employees' + urlParamsV2;
    return getApi<FetchMissingReportListResponse<T>>({
      url,
      responseSchema: {},
    });
  },

  sendReminder: (payload: SendReminderPayload) => {
    return postApi<SendReminderResponse, SendReminderPayload>({
      url: '/missing-report/reminders/send',
      requestData: payload,
      responseSchema: {},
    });
  },
};

export default missingInformationReport;
